const EventBus = (() => {
    // variable to hold registered events
    let instance;
  
    function createInstance() {
      return {};
    }
  
    return {
      getInstance() {
        if (!instance) {
          instance = createInstance();
        }
        return instance;
      },
      // to register an event
      on(key, cb) {
        this.getInstance();
        // if it didnt exist create entry
        if (instance[key] == null) {
          instance[key] = cb;
        } else {
          // if already array (with multiple callbacks)
          if (instance[key] && Array.isArray(instance[key])) {
            instance[key] = [...instance[key], cb];
          }
          // if already contains value but not an array, turn to array
          if (instance[key] && !Array.isArray(instance[key])) {
            instance[key] = [instance[key], cb];
          }
        }
      },
      // to deregister an event
      off(key, cb) {
        if (!instance[key]) return;

        // 콜백이 지정되지 않으면 전체 키 삭제 (기존 동작 유지)
        if (!cb) {
          delete instance[key];
          return;
        }

        // 콜백이 지정된 경우 해당 콜백만 제거
        if (Array.isArray(instance[key])) {
          instance[key] = instance[key].filter(callback => callback !== cb);
          // 배열이 비었으면 키 삭제
          if (instance[key].length === 0) {
            delete instance[key];
          }
        } else if (instance[key] === cb) {
          // 단일 콜백이고 같으면 키 삭제
          delete instance[key];
        }
      },
      // to emit an event
      emit(key, ...args) {
        this.getInstance();  // listener 등록 전 emit 호출 시 instance 보장
        if (instance[key] != null) {
          if (Array.isArray(instance[key])) {
            instance[key].forEach(cb => {
              cb(...args);
            });
          }
          if (!Array.isArray(instance[key])) {
            instance[key](...args);
          }
        }
      },
      // to clear all registered events
      clear() {
        instance = {};
      }
    };
  })();
  
  export default EventBus;